import { API_ENDPOINTS } from "@/api/services/attendance/apiEndPoint";
import { ApprovalsListApi } from "../approvals/Approvals";
import { calendarListApi } from "../calendar/Calendar";
import { baseApi } from "@/utils/baseApi";

export const RegularizationListApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getEmployeeRegularization: builder.query({
      query: ({ key }) => ({
        url: API_ENDPOINTS.ATTENDANCE.GET_EMPLOYEE_REGULARIZATION(key),
      }),
      providesTags: ["Regularization"],
    }),

    withdrawRegularization: builder.mutation({
      query: ({ empId, regCode, yearMonth }) => ({
        url: API_ENDPOINTS.ATTENDANCE.GET_WITHDRAW_REGULARIZATION(
          empId,
          regCode,
          yearMonth
        ),
        method: "DELETE",
      }),
      invalidatesTags: [
        "AbsentPresntList",
        "QuickAdd",
        "AbsentPresnt",
        "Regularization",
      ],

      // ✅ trigger refetch of another slice's query
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(calendarListApi.util.invalidateTags(["Calendar"]));
        } catch (error) {
          // console.error("withdrawRegularization failed:", error);
        }
      },
    }),

    // quick add
    getQuickAdd: builder.query({
      query: ({ yearMonth }) => ({
        url: API_ENDPOINTS.ATTENDANCE.GET_QUICK_ADD(yearMonth),
      }),
      providesTags: ["QuickAdd"],
    }),

    // Absent-Present
    getAbsentPresent: builder.query({
      query: ({ yearMonth }) => ({
        url: API_ENDPOINTS.ATTENDANCE.GET_ABSENT_PRESENT(yearMonth),
      }),
      providesTags: ["AbsentPresnt"],
    }),

    // Absent-Present-list
    getAbsentPresentList: builder.query({
      query: ({ yearMonth }) => ({
        url: API_ENDPOINTS.ATTENDANCE.GET_ABSENT_PRESENT_LIST(yearMonth),
      }),
      providesTags: ["AbsentPresntList"],
    }),

    // applied to
    getAppliedTo: builder.query({
      query: () => ({ url: API_ENDPOINTS.ATTENDANCE.GET_APPLIED_TO() }),
      providesTags: ["Regularization"],
    }),

    // Apply regularization
    applyRegularization: builder.mutation({
      query: (data) => ({
        url: API_ENDPOINTS.ATTENDANCE.POST_APPLY_REGULARIZATION(),
        method: "POST",
        body: data,
      }),
      invalidatesTags: [
        "AbsentPresntList",
        "QuickAdd",
        "AbsentPresnt",
        "Regularization",
      ],
      // ✅ trigger refetch of another slice's query
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(calendarListApi.util.invalidateTags(["Calendar"]));
        } catch (error) {
          // console.error("applyRegularization failed:", error);
        }
      },
    }),

    getSwipeDetails: builder.query({
      query: ({ empID }) => ({
        url: API_ENDPOINTS.ATTENDANCE.SWIPE_DETAILS(empID),
      }),
      extraOptions: { sourceType: "THIRD_PARTY" },
    }),

     getSwipeworkHours: builder.query({
      query: ({ empID,dateObj }) => ({
        url: API_ENDPOINTS.ATTENDANCE.SWIPE_WORK_DETAILS(empID,dateObj),
      }),
      extraOptions: { sourceType: "THIRD_PARTY" },
    }),

    getSwipeDetailsDate: builder.query({
      query: ({ empID, Date }) => ({
        url: API_ENDPOINTS.ATTENDANCE.SWIPE_DETAILS_DATE(empID, Date),
      }),
    }),

    // put call
    approveRegularization: builder.mutation({
      query: ({
        empId,
        regCode,
        key,
        approvedDate,
        rejectedDate,
        remarks,
      }) => ({
        url: API_ENDPOINTS.ATTENDANCE.GET_APPROVE_REGULARIZATION(
          empId,
          regCode,
          key,
          approvedDate,
          rejectedDate,
          remarks
        ),
        method: "PUT",
      }),
      invalidatesTags: ["Regularization"],

      // ✅ trigger refetch of another slice's query
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(ApprovalsListApi.util.invalidateTags(["Approvals"]));
        } catch (error) {
          // console.error("approveRegularization failed:", error);
        }
      },
    }),
  }),
});

export const {
  useGetEmployeeRegularizationQuery,
  useApproveRegularizationMutation,
  useWithdrawRegularizationMutation,
  useGetQuickAddQuery,
  useGetAppliedToQuery,
  useGetAbsentPresentQuery,
  useApplyRegularizationMutation,
  useGetAbsentPresentListQuery,
  useGetSwipeDetailsQuery,
  useLazyGetSwipeDetailsQuery,
  useGetSwipeDetailsDateQuery,
  useLazyGetSwipeworkHoursQuery
} = RegularizationListApi;
